import Vue from "vue"
import Router from "vue-router"
import store from "../store/index"
import cookies from "vue-cookies"

// import HelloWorld from '@/components/index'
import HelloWorld from "@/components/index"
// 解决方案
import Solution from "@/components/solution/index"
import CaseDetails from "@/components/solution/solutionDetails"
// 新闻
import News from "@/components/news/index"
import NewDetails from "@/components/news/newDetails"
// 园区动态
import Park from "@/components/park/index"
// 园区详情内容
import ParkDetails from "@/components/park/parkDetails"
// 园区详情
import AllPark from "@/components/park/allPark"
// 查看更多
import ParkDynamic from "@/components/park/parkDynamic"
// vr视频
import zengcaicloudVideo from "@/components/parkSwiper/zengcaicloudVideo"
// // 设计市场-活动列表页
import activeList from "@/components/design/activeList/activeList"
// // 设计市场-活动详情
import activeDetail from "@/components/design/activeList/activeDetail"
// // 设计市场-活动详情--参赛作品详情
import worksDetails from "@/components/design/activeList/worksDetails"
// // 设计市场-活动详情--获奖作品详情
import winDetails from "@/components/design/activeList/winDetails"

// vr全景测试
import Veiws from "@/components/park/allMap/veiws"
// 测试VR
import VeiwsUrl from "@/components/park/VeiwsUrl"

// 我要打印-服务商首页
import PrintServiceIndex from "@/components/print/printServiceIndex"

import enterpriseVeiws from "@/components/park/allMap/enterpriseVeiws"
// 3D商城
import mall from "@/components/threeShop/index"
// 3D商城-商品列表
import ShopGoodsList from "@/components/threeShop/shopGoodsList"
// 3D商城-商品详情
import ShopGoodDetails from "@/components/threeShop/shopGoodDetails"
import ShopAffirmOrder from "@/components/threeShop/shopAffirmOrder"
import ShopSendSuccess from "@/components/threeShop/shopSendSuccess"
// 3D商城-商城列表
import ShopMallList from "@/components/threeShop/shopMallList"
// 3D商城-商家入驻
import ShopServiceAuthentication from "@/components/threeShop/shopServiceAuthentication"

// 商机线索
import businessSearch from "@/components/businessSearch/index"
// 商机线索列表页
import businessSearchList from "@/components/businessSearch/businessSearchList"
// 商机线索详情页
import businessSearchDetails from "@/components/businessSearch/businessSearchDetails"
// 商机活动详情页
import businessActivityDetails from "@/components/businessSearch/businessActivityDetails"

//创新服务
import innovateService from "@/components/innovateService/index"
//创新服务——企业风采
import elegantList from "@/components/innovateService/elegantList"
//创新服务——企业风采详情
import elegantDetail from "@/components/innovateService/elegantDetail"
//创新服务详情页
import innovateDetail from "@/components/innovateService/innovateDetail"
//企业诊断
import businessDiagnosis from "@/components/businessDiagnosis/index"
//企业诊断-培训直播-查看更多
import diagnosisVLList from "@/components/businessDiagnosis/diagnosisVLList"
//企业诊断-培训视频详情页
import diagnosisDetail from "@/components/businessDiagnosis/diagnosisDetail"
//人才服务
import talentServices from "@/components/talentServices/index"
//人才服务-缴费入口
import payEnterance from "@/components/talentServices/payEnterance"
//人才服务-直播公开课列表
import liveOpenList from "@/components/talentServices/liveOpenList"
//人才服务-直播公开课详情
import liveOpenDetail from "@/components/talentServices/liveOpenDetail"
//人才服务-线上精品课程列表
import onlineCourseList from "@/components/talentServices/onlineCourseList"
//人才服务-线上精品课程详情
import onlineCourseDetail from "@/components/talentServices/onlineCourseDetail"
//人才服务-线上精品课程视频
import onlineCourseVideo from "@/components/talentServices/onlineCourseVideo"
//人才服务-线下专题培训列表
import trainingCourseList from "@/components/talentServices/trainingCourseList"
//资源池
import resourcePool from "@/components/resourcePool/index"
//资源池——专家详情
import expertDetail from "@/components/resourcePool/expertDetail"
//资源池——服务商列表
import providerList from "@/components/resourcePool/providerList"
//资源池——服务商详情
import providerDetail from "@/components/resourcePool/providerDetail"
//新闻咨询
import newsConsult from "@/components/newsConsult/index"
// 数字化服务
import digitalize from "@/components/digitalize/index"
// 数字化服务列表
import digServiceList from "@/components/digitalize/digServiceList"
// 数字化服务详情
import digServiceDetail from "@/components/digitalize/digServiceDetail"
// 首页——政务直播列表页
import homeLiveList from "@/components/newHome/govLiveList"
// 首页——政务直播详情
import homeLiveDetail from "@/components/newHome/govLiveDetail"
// 首页——服务中心内容详情
import serviceCenter from "@/components/newHome/serviceCenter"
// 首页——案例内容详情
import caseDetail from "@/components/newHome/caseDetail"
// 首页——典型案例列表页
import caseList from "@/components/newHome/caseList"
// 项目申报——项目列表页
import projectApply from "@/components/projectApply/index"
// 项目申报——项目申报页
import projectReport from "@/components/projectApply/projectReport"
// 企业诊断——企业上云
import cloudUp from "@/components/enterpriseCloudUp/index"
// 企业诊断——企业上云步骤
import fillStep from "@/components/enterpriseCloudUp/fillStep"

// 政务
import govInfo from "@/components/govInfo/index"
// 政务列表页
import govInfoList from "@/components/govInfo/infoList"
// 政务详情
import govInfoDetail from "@/components/govInfo/infoDetail"
// 直播列表
import govLiveList from "@/components/govInfo/liveList"
// 视频列表
import govVideoList from "@/components/govInfo/videoList"
// 播放列表
import govPlayDetail from "@/components/govInfo/playDetail"

// 软件市场
import apps from "@/components/saas/index"
// 软件超市详情页
import SaasDetails from "@/components/saas/saasDetails"
// 软件超市列表页
import SaasList from "@/components/saas/saasList"

// 注册
import Registered from "@/components/registeredLogin/registeredIndex"
// 注册成功
import RegSuccess from "@/components/registeredLogin/regSuccess"

// 登录
import Login from "@/components/registeredLogin/loginIndex"
// 登录获取code空页面
import LoginCode from "@/components/registeredLogin/LoginCode"
// 忘记密码
import forgetPassword from "@/components/registeredLogin/forgetPassword"
//
import UserCenter from "@/components/registeredLogin/userCenter/index"
// 个人中心--实名认证
import CertificationCenter from "@/components/registeredLogin/certificationCenter/index"
// 个人中心--企业认证
import EnterCertification from "@/components/registeredLogin/certificationCenter/enterCertification"
// 个人中心--企业管理
import EnterpriseCenter from "@/components/registeredLogin/enterpriseCenter/index"
// 403页面
import Undefined from "@/components/undefined"
// 在线资讯
import onlineConsult from "@/components/header/onlineConsult"
// 帮助中心
import helpCenter from "@/components/helpCenter/helpCenter"
// 帮助中心详情
import helpCenterDetail from "@/components/helpCenter/helpCenterDetail"
// 购物车
import shopCar from "@/components/threeShop/shopCar"

// 商品下架
import shelves from "@/components/shelves/shelves"

// 积分活动
import integralActivities from "@/components/integral/integralActivities"
import activeShopGoodDetails from "@/components/integral/shopGoodDetails"
import activeShopAffirmOrder from "@/components/integral/shopAffirmOrder"
import activeShopSendSuccess from "@/components/integral/shopSendSuccess"

// 集采活动
import collectActivitiesHome from "@/components/collect/collectActivitiesHome"
import collectActivities from "@/components/collect/collectActivities"
import collectShopGoodDetails from "@/components/collect/shopGoodDetails"
import collectShopAffirmOrder from "@/components/collect/shopAffirmOrder"
import collectShopSendSuccess from "@/components/collect/shopSendSuccess"

// 中心详情
import centerDetails from "@/components/centerDetails/centerDetails"
import cases from "@/components/cases/cases"

// 协会
import association from "@/components/association/index"
// 协会动态
import dynamicState from "@/components/association/dynamicState"
// 会员单位
import member from "@/components/association/member"
// 协会介绍
import introduction from "@/components/association/introduction"
// 协会新闻内容
import introductionNews from "@/components/association/components/newDetails"
// 赋码追溯系统
import codeTraceability from "@/components/codeTraceability/index"

// 赋码追溯企业
import codeTraceabilityOther from "@/components/codeTraceabilityOther/index"
// 赋码追溯首页
import reversoContext from "@/components/reversoContext/index"

// 协会首页
import supplyHome from "@/components/supplyHome/index"
import enter from "@/components/supplyHome/components/enter" // 服务商入驻
import demandList from "@/components/supplyHome/components/list/demandList" // 需求列表
import demandDetails from "@/components/supplyHome/components/details/demandDetails" // 需求详情
import serviceList from "@/components/supplyHome/components/list/serviceList" // 服务列表
import serviceDetails from "@/components/supplyHome/components/details/serviceDetails" // 服务详情
import dynamicsList from "@/components/supplyHome/components/list/dynamicsList" // 对接案例列表
import dynamicsDetails from "@/components/supplyHome/components/details/dynamicsDetails" // 对接案例详情
import offlineList from "@/components/supplyHome/components/list/offlineList" // 线下撮合列表
import offlineDetails from "@/components/supplyHome/components/details/offlineDetails" // 线下撮合详情
import qualityServiceProviderList from "@/components/supplyHome/components/list/qualityServiceProviderList" // 优质服务商列表
import qualityServiceProviderDetails from "@/components/supplyHome/components/details/qualityServiceProviderDetails" // 优质服务商详情

import productHome from "@/components/product/index" // 产品选型首页
import productList from "@/components/product/productList" // 产品选型列表页
import specList from "@/components/product/specList" // 产品规格列表页
import newSpecList from "@/components/product/newSpecList" // 新 产品规格列表页
import productDetails from "@/components/product/productDetails" // 产品详情
import seriesDetails from "@/components/product/seriesDetails" // 系列详情
import productCompare from "@/components/product/productCompare" // 产品对比
import productOrderPage from "@/components/product/productOrderPage" // 立即下单页面
import specOrderCar from "@/components/product/specOrderCar" // 立即下单页面

import lineDetails from "@/components/supplyHome/components/list/lineDetails" // 撮合详情

import { cookie } from "request"

Vue.use(Router)
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

let router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      name: "home",
      // component:HelloWorld,
      // component: resolve => require(['@/components/index'], resolve),
      component: (resolve) => require(["@/components/newHome/index"], resolve),
      children: [],
      meta: {
        // title: '宁夏工业企业数字化转型公共服务平台— 水泵行业综合性工业互联网平台！',
        title: "宁夏工业企业数字化转型公共服务平台—助力全区工业企业数字化转型！",
        content: {
          keywords: "数字化转型 | 平台 | 数字化转型服务平台 | 工业数字化转型平台 | 企业数字化转型支撑平台 | 数字化转型升级平台 | 数字化转型评价平台 | 数字化转型工作平台 | 工业企业 | 公共服务平台",
          description: "宁夏工业企业数字化转型公共服务平台为您提供全方位的数字化转型支持和服务,助力企业提升竞争力和创新能力。选择我们,开启数字化转型之旅！"
        }
      },
    },
    {
      path: "/home",
      name: "home",
      // component: HelloWorld,
      // component: resolve => require(['@/components/index'], resolve),
      component: (resolve) => require(["@/components/newHome/index"], resolve),
      meta: {
        title:
          "宁夏工业企业数字化转型公共服务平台",
      },
    },
    {
      path: "/solution",
      name: "solution",
      component: Solution,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—解决方案",
      },
    },
    {
      path: "/caseDetails/:uuid",
      name: "caseDetails",
      component: CaseDetails,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—解决方案",
      },
    },
    // cases 案列列表
    {
      path: "/cases",
      name: "cases",
      component: cases,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—客户案列",
      },
    },
    {
      path: "/news",
      name: "news",
      component: News,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-行业资讯",
      },
    },
    {
      path: "/news/newDetails/:uuid",
      name: "newDetails",
      component: (resolve) =>
        require(["@/components/news/newDetails"], resolve),
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-行业资讯",
      },
    },
    {
      path: "/park",
      name: "park",
      component: Park,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—泵都风采",
      },
    },
    // 中心详情
    // centerDetails
    {
      path: "/centerDetails/:uuid",
      name: "centerDetails",
      // component: HelloWorld,
      component: centerDetails,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-中心详情",
      },
    },
    {
      path: "/parkDetails/:uuid",
      name: "parkDetails",
      component: ParkDetails,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—泵都风采",
      },
    },
    {
      path: "/allPark/:uuid",
      name: "allPark",
      component: AllPark,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—泵都风采",
      },
    },
    {
      path: "/parkDynamic/:uuid?",
      name: "parkDynamic",
      component: ParkDynamic,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—泵都风采",
      },
    },
    {
      path: "/zengcaicloudVideo",
      name: "zengcaicloudVideo",
      component: zengcaicloudVideo,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—共享智能铸造产业创新中心",
      },
    },
    // vr全景测试
    {
      path: "/veiws/:uuid",
      name: "veiws",
      component: Veiws,
      // component: () => import ('@/components/park/allMap/veiws'),
      hidden: true,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—泵都风采",
      },
    },
    // vr全景测试
    {
      path: "/VeiwsUrl",
      name: "VeiwsUrl",
      component: VeiwsUrl,
      hidden: true,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—泵都风采",
      },
    },
    // 企业VR全景
    {
      path: "/enterpriseVeiws/:uuid",
      name: "enterpriseVeiws",
      component: enterpriseVeiws,
      // component: () => import ('@/components/park/allMap/veiws'),
      hidden: true,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—泵都风采",
      },
    },
    // 我要打印-服务商首页
    {
      path: "/printServiceIndex/:enterPriseId/:pageIndex?",
      name: "printServiceIndex",
      component: PrintServiceIndex,
      meta: {
        title:
          "宁夏工业企业数字化转型公共服务平台—宁夏工业企业数字化转型公共服务平台商",
      },
    },
    // 3D商城
    {
      path: "/mall",
      name: "mall",
      component: mall,
      meta: {
        title:
          "宁夏工业企业数字化转型公共服务平台—宁夏工业企业数字化转型公共服务平台商",
      },
    },
    // 我的购物车
    {
      path: "/shopCar",
      name: "shopCar",
      component: shopCar,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—我的购物车",
      },
    },
    // 3D商城-商品列表页
    {
      path: "/shopGoodsList/:uuid?/:secondUuid?/:thirdUuid?",
      name: "shopGoodsList",
      component: ShopGoodsList,
      meta: {
        title:
          "宁夏工业企业数字化转型公共服务平台—宁夏工业企业数字化转型公共服务平台商",
      },
    },
    // 3D商城-商品详情
    {
      path: "/shopGoodDetails/:uuid",
      name: "shopGoodDetails",
      component: ShopGoodDetails,
      meta: {
        title:
          "宁夏工业企业数字化转型公共服务平台—宁夏工业企业数字化转型公共服务平台商",
      },
    },
    // 立即购买
    {
      path: "/shopAffirmOrder",
      name: "shopAffirmOrder",
      component: ShopAffirmOrder,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-商城下单",
      },
    },
    // 购买成功
    {
      path: "/shopSendSuccess/:orderCode",
      name: "shopSendSuccess",
      component: ShopSendSuccess,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-下单成功",
      },
    },
    // 3D商城-商城列表
    {
      path: "/MallList",
      name: "shopMallList",
      component: ShopMallList,
      meta: {
        title:
          "宁夏工业企业数字化转型公共服务平台—宁夏工业企业数字化转型公共服务平台商",
      },
    },
    {
      path: "/shopServiceAuthentication",
      name: "shopServiceAuthentication",
      component: ShopServiceAuthentication,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台—商家入驻",
      },
    },
    // 商机线索
    {
      path: "/businessSearch",
      name: "businessSearch",
      component: businessSearch,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-商机线索",
      },
    },
    // 商机线索列表页
    {
      path: "/businessSearchList",
      name: "businessSearchList",
      component: businessSearchList,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-商机线索",
      },
    },
    // 商机线索详情页
    {
      path: "/businessSearchDetails/:uuid",
      name: "businessSearchDetails",
      component: businessSearchDetails,
      hidden: true,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-商机线索",
      },
    },
    // 商机活动详情页
    {
      path: "/businessActivityDetails/:uuid",
      name: "businessActivityDetails",
      component: businessActivityDetails,
      hidden: true,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-商机活动",
      },
    },
    // 创新服务
    {
      path: "/innovateService",
      name: "innovateService",
      component: innovateService,
      meta: {
        title: "创新服务-公共服务平台",
        content: {
          keywords: "知识产权|知产运用|知产保护|知产服务|项目申报|标准管理",
          description: "宁夏工业企业数字化转型公共服务创新服务平台全面保障您的知识产权权益,获取最新知识产权维权政策,保障您的创新成果。"
        }
      },
    },
    // 创新服务——详情页
    {
      path: "/innovateDetail",
      name: "innovateDetail",
      component: innovateDetail,
      meta: {
        title: "创新服务——内容详情",
      },
    },
    // 创新服务——企业风采
    {
      path: "/elegantList",
      name: "elegantList",
      component: elegantList,
      meta: {
        title: "创新服务——企业风采列表",
      },
    },
    // 创新服务——企业风采详情
    {
      path: "/elegantDetail",
      name: "elegantDetail",
      component: elegantDetail,
      meta: {
        title: "创新服务——企业风采详情",
      },
    },
    // 企业诊断
    {
      path: "/businessDiagnosis",
      name: "businessDiagnosis",
      component: businessDiagnosis,
      meta: {
        title: "企业诊断",
      },
    },
    // 企业诊断-培训直播-查看更多
    {
      path: "/diagnosisVLList",
      name: "diagnosisVLList",
      component: diagnosisVLList,
      meta: {
        title: "企业诊断-培训直播",
      },
    },
    // 企业诊断-培训详情
    {
      path: "/diagnosisDetail",
      name: "diagnosisDetail",
      component: diagnosisDetail,
      meta: {
        title: "企业诊断-企业诊断培训详情",
      },
    },
    // 人才服务
    {
      path: "/talentServices",
      name: "talentServices",
      component: talentServices,
      meta: {
        title: "人才服务-数字化转型人才服务数字化平台-公共服务平台",
        content: {
          keywords: "数字化|数字化转型|数字化转型行业培训 |数字化转型人才服务直播公开课|职称评审服务|线下专题培训|继续教育课程|线上精品课程",
          description: "宁夏工业企业数字化转型公共服务人才服务平台提供工业企业数字化转型学习课程、企业培训、直播课等服务，为行业企业提供人才支撑。"
        }
      },
    },
    // 人才服务-缴费入口
    {
      path: "/payEnterance",
      name: "payEnterance",
      component: payEnterance,
      meta: {
        title: "人才服务-缴费入口",
      },
    },
    // 人才服务-直播公开课列表
    {
      path: "/liveOpenList",
      name: "liveOpenList",
      component: liveOpenList,
      meta: {
        title: "直播列表-人才服务-公共服务平台",
        content: {
          keywords: "数字化| 数字化转型课程直播 | 数字化基础知识培训直播 | 企业培训 | 数字化转型知识",
          description: "专注于企业数字化转型课程的内容，帮助中小企业实现数字化转型升级。拥有丰富的课程资源、讲师资源，提供企业线上培训、新员工培训、在线培训考试、企业内训等服务，助力工业企业智能数字化转型。"
        }
      },
    },
    // 人才服务-直播公开课详情
    {
      path: "/liveOpenDetail",
      name: "liveOpenDetail",
      component: liveOpenDetail,
      meta: {
        title: "人才服务-直播公开课详情",
      },
    },
    // 人才服务-线上精品课程列表
    {
      path: "/onlineCourseList",
      name: "onlineCourseList",
      component: onlineCourseList,
      meta: {
        title: "线上精品课程-人才服务-公共服务平台",
        content: {
          keywords: "数字化 | 数字化课程 | 数字化转型课程 | 工业企业数字化转型课程 | 企业培训",
          description: "专注于企业数字化转型课程的内容，帮助中小企业实现数字化转型升级。拥有丰富的课程资源、讲师资源，提供企业线上培训、新员工培训、在线培训考试、企业内训等服务，助力工业企业智能数字化转型。"
        }
      },
    },
    // 人才服务-线上精品课程详情
    {
      path: "/onlineCourseDetail",
      name: "onlineCourseDetail",
      component: onlineCourseDetail,
      meta: {
        title: "人才服务-线上精品课程详情",
      },
    },
    // 人才服务-线上精品课程视频
    {
      path: "/onlineCourseVideo",
      name: "onlineCourseVideo",
      component: onlineCourseVideo,
      meta: {
        title: "人才服务-线上精品课程视频",
      },
    },
    // 人才服务-线下专题培训列表
    {
      path: "/trainingCourseList",
      name: "trainingCourseList",
      component: trainingCourseList,
      meta: {
        title: "线下专题培训-人才服务-公共服务平台",
        content: {
          keywords: "数字化 | 数字化专题培训 | 数字化转型专题培训 | 工业企业数字化转型培训 | 企业培训",
          description: "专注于企业数字化转型课程的内容，帮助中小企业实现数字化转型升级。拥有丰富的课程资源、讲师资源，提供企业线上培训、新员工培训、在线培训考试、企业内训等服务，助力工业企业智能数字化转型。"
        }
      },
    },
    // 新闻咨询
    {
      path: "/newsConsult",
      name: "newsConsult",
      component: newsConsult,
      meta: {
        title: "新闻资讯-提供全面的行业新闻资讯-公共服务平台",
        content: {
          keywords: "数字化转型 | 数字化新闻资讯| 数字化转型新闻资讯 | 工业企业新闻资讯 | 公共服务平台",
          description: "宁夏工业企业数字化转型公共服务新闻资讯平台为企业提供最新数字化相关新闻资讯，帮助企业获取最新行业政策。"
        }
      },
    },
    // 数字化服务
    {
      path: "/digitalize",
      name: "digitalize",
      component: digitalize,
      meta: {
        title: "数字化服务-公共服务平台",
        content: {
          keywords: "数字化 | 数字化转型 |特色服务 | 公共服务 |装备制造全流程运营管控平台 FOM | 云ERP解决方案 | EHS管理解决方案 |体系管理 | 多场景数字化解决方案",
          description: "宁夏工业企业数字化转型公共服务数字化服务平台，联合数字化转型服务商，向全区装备制造、化工、冶金、新材料等行业，提供智能装备、工业软件、咨询规划等解决方案服务。"
        }
      },
    },
    // 数字化服务列表
    {
      path: "/digServiceList",
      name: "digServiceList",
      component: digServiceList,
      meta: {
        title: "数字化服务列表",
      },
    },
    // 数字化服务详情
    {
      path: "/digServiceDetail",
      name: "digServiceDetail",
      component: digServiceDetail,
      meta: {
        title: "数字化服务详情",
      },
    },
    // 资源池
    {
      path: "/resourcePool",
      name: "resourcePool",
      component: resourcePool,
      meta: {
        title: "资源池- 为工业企业提供优质资源-公共服务平台",
        content: {
          keywords: "专家| 服务商 | 服务商服务能力| 数字化转型| 企业数字化服务| 转型案例",
          description: "宁夏工业企业数字化转型公共服务资源池平台，汇聚优质专家、服务商资源,为工业互联网提供服务支持及解决方案。"
        }
      },
    },
    // 首页——政务直播列表
    {
      path: "/homeLiveList",
      name: "homeLiveList",
      component: homeLiveList,
      meta: {
        title: "政务直播列表",
      },
    },
    // 首页——政务直播详情
    {
      path: "/homeLiveDetail",
      name: "homeLiveDetail",
      component: homeLiveDetail,
      meta: {
        title: "政务直播详情",
      },
    },
    // 首页——服务中心内容详情
    {
      path: "/serviceCenter",
      name: "serviceCenter",
      component: serviceCenter,
      meta: {
        title: "服务中心内容详情",
      },
    },
    // 首页——案例内容详情
    {
      path: "/caseDetail",
      name: "caseDetail",
      component: caseDetail,
      meta: {
        title: "案例内容详情",
      },
    },
    // 首页——典型案例列表
    {
      path: "/caseList",
      name: "caseList",
      component: caseList,
      meta: {
        title: "典型案例列表",
      },
    },
    // 项目申报-项目列表页
    {
      path: "/projectApply",
      name: "projectApply",
      component: projectApply,
      meta: {
        title: "项目列表",
      },
    },
    // 项目申报-项目申报页
    {
      path: "/projectReport",
      name: "projectReport",
      component: projectReport,
      meta: {
        title: "项目申报",
      },
    },
    // 企业诊断——企业上云
    {
      path: "/cloudUp",
      name: "cloudUp",
      component: cloudUp,
      meta: {
        title: "企业诊断-提供中小企业诊断服务-公共服务平台",
        content: {
          keywords: "智能制造|两化融合|企业上云|中小企业数字化水平|培训填报|企业指标",
          description: "宁夏工业企业数字化转型公共服务企业诊断平台提供中小企业诊断服务,为企业制定针对性管理方案,解决经营难题,提升竞争力。"
        }
      },
    },
    // 企业诊断——企业上云步骤
    {
      path: "/fillStep",
      name: "fillStep",
      component: fillStep,
      meta: {
        title: "上云填报-公共服务平台",
        content: {
          keywords: "智能制造|两化融合|企业上云|中小企业数字化水平|培训填报|企业指标|上云填报|填报申请",
          description: "宁夏工业企业数字化转型公共服务企业诊断平台提供中小企业诊断服务,为企业制定针对性管理方案,解决经营难题,提升竞争力。"
        }
      },
    },
    // 资源池——专家详情
    {
      path: "/expertDetail",
      name: "expertDetail",
      component: expertDetail,
      meta: {
        title: "资源池——专家详情",
      },
    },
    // 资源池——服务商列表
    {
      path: "/providerList",
      name: "providerList",
      component: providerList,
      meta: {
        title: "服务商-公共服务平台",
        content: {
          keywords: "数字化|服务商|服务能力|转型案例|解决方案",
          description: "宁夏工业企业数字化转型公共服务资源池平台，汇聚优质专家、服务商资源,为工业互联网提供服务支持及解决方案。"
        }
      },
    },
    // 资源池——服务商详情
    {
      path: "/providerDetail",
      name: "providerDetail",
      component: providerDetail,
      meta: {
        title: "资源池——服务商详情",
      },
    },
    // 政务信息
    {
      path: "/govInfo",
      name: "govInfo",
      component: govInfo,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-政务信息",
      },
    },
    // 政务列表页
    {
      path: "/govInfoList",
      name: "govInfoList",
      component: govInfoList,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-政务列表",
      },
    },
    // 政务详情
    {
      path: "/govInfoDetail",
      name: "govInfoDetail",
      component: govInfoDetail,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-政务详情",
      },
    },
    // 直播列表
    {
      path: "/govLiveList",
      name: "govLiveList",
      component: govLiveList,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-政务直播",
      },
    },
    // 视频列表
    {
      path: "/govVideoList",
      name: "govVideoList",
      component: govVideoList,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-政务视频",
      },
    },
    // 视频列表
    {
      path: "/govPlayDetail",
      name: "govPlayDetail",
      component: govPlayDetail,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-视频播放",
      },
    },
    // 软件市场
    {
      path: "/apps",
      name: "apps",
      component: apps,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-应用市场",
      },
    },
    // 软件超市详情页
    {
      path: "/appsDetails/:uuid",
      name: "saasDetails",
      component: SaasDetails,
      hidden: true,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-应用市场",
      },
    },
    // 软件超市列表页
    {
      // path: '/appsList/:tabParam/:search',
      path: "/appsList",
      name: "saasList",
      component: SaasList,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-应用市场",
      },
    },
    // 注册
    {
      path: "/registered",
      name: "registered",
      component: Registered,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-注册",
        requireAuth: true,
      },
    },
    // 注册成功
    {
      path: "/regSuccess",
      name: "regSuccess",
      component: RegSuccess,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-注册",
        requireAuth: true,
      },
    },

    // 登录
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-登录",
        requireAuth: true,
      },
    },
    // 登录跳转的空页面
    {
      path: "/loginCode",
      name: "loginCode",
      component: LoginCode,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-登录",
        requireAuth: true,
      },
    },
    // 忘记密码
    {
      path: "/forgetPassword",
      name: "forgetPassword",
      component: forgetPassword,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-忘记密码",
        requireAuth: true,
      },
    },
    // 个人中心
    {
      path: "/userCenter/:userServeId",
      name: "userCenter",
      component: UserCenter,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-个人中心",
      },
    },
    // 个人中心--实名认证
    {
      path: "/certificationCenter",
      name: "certificationCenter",
      component: CertificationCenter,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-个人中心",
      },
    },
    // 个人中心--企业认证
    {
      path: "/enterCertification",
      name: "enterCertification",
      component: EnterCertification,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-个人中心",
      },
    },
    // 个人中心--企业管理
    {
      path: "/enterpriseCenter",
      name: "enterpriseCenter",
      component: EnterpriseCenter,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-个人中心",
      },
    },
    // 403页面
    {
      path: "/undefined",
      name: "undefined",
      component: Undefined,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-403页面",
      },
    },
    // 在线咨询
    {
      path: "/onlineConsult",
      name: "onlineConsult",
      component: onlineConsult,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-在线咨询",
      },
    },
    // 帮助中心
    {
      path: "/helpCenter",
      name: "helpCenter",
      component: helpCenter,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-帮助中心",
      },
    },
    // 帮助中心详情
    {
      path: "/helpCenterDetail",
      name: "helpCenterDetail",
      component: helpCenterDetail,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-帮助中心详情页",
      },
    },
    {
      path: "/shelves",
      name: "shelves",
      component: shelves,
      meta: {
        title: "商品下架",
      },
    },
    {
      path: "/integralActivities/:uuid",
      name: "integralActivities",
      component: integralActivities,
      meta: {
        title: "积分活动",
      },
    },
    {
      path: "/activeShopGoodDetails",
      name: "activeShopGoodDetails",
      component: activeShopGoodDetails,
      meta: {
        title: "积分活动商品详情",
      },
    },
    // 立即购买
    {
      path: "/activeShopAffirmOrder",
      name: "activeShopAffirmOrder",
      component: activeShopAffirmOrder,
      meta: {
        title: "积分活动商品下单",
      },
    },
    // 购买成功
    {
      path: "/activeShopSendSuccess/:orderCode",
      name: "activeShopSendSuccess",
      component: activeShopSendSuccess,
      meta: {
        title: "积分活动商品下单成功",
      },
    },
    {
      path: "/collectActivitiesHome",
      name: "collectActivitiesHome",
      component: collectActivitiesHome,
      meta: {
        title: "集采活动",
      },
    },
    {
      path: "/collectActivities/:uuid",
      name: "collectActivities",
      component: collectActivities,
      meta: {
        title: "集采活动",
      },
    },
    {
      path: "/collectShopGoodDetails",
      name: "collectShopGoodDetails",
      component: collectShopGoodDetails,
      meta: {
        title: "集采活动商品详情",
      },
    },
    // 立即购买
    {
      path: "/collectShopAffirmOrder",
      name: "collectShopAffirmOrder",
      component: collectShopAffirmOrder,
      meta: {
        title: "集采活动商品下单",
      },
    },
    // 购买成功
    {
      path: "/collectShopSendSuccess/:orderCode",
      name: "collectShopSendSuccess",
      component: collectShopSendSuccess,
      meta: {
        title: "集采活动商品下单成功",
      },
    },
    // 协会首页
    {
      path: "/association",
      name: "association",
      component: association,
      meta: {
        title: "协会首页",
      },
    },
    // 协会动态
    {
      path: "/dynamicState",
      name: "dynamicState",
      component: dynamicState,
      meta: {
        title: "协会动态",
      },
    },
    // 会员单位
    {
      path: "/member",
      name: "member",
      component: member,
      meta: {
        title: "会员单位",
      },
    },
    // 协会介绍
    {
      path: "/introduction",
      name: "introduction",
      component: introduction,
      meta: {
        title: "协会介绍",
      },
    },
    // 协会介绍
    {
      path: "/introduction/introductionNews/:uuid",
      name: "introductionNews",
      component: (resolve) =>
        require(["@/components/association/components/newDetails"], resolve),
      meta: {
        title: "协会新闻",
      },
    },
    // 设计市场-活动列表页
    {
      path: "/activeList",
      name: "activeList",
      component: activeList,
      meta: {
        title: "活动列表页",
      },
    },
    // 设计市场-活动列表页
    {
      path: "/activeDetail/:uuid?",
      name: "activeDetail",
      component: activeDetail,
      meta: {
        title: "活动详情",
      },
    },
    // 设计市场-活动详情--参赛作品详情
    {
      path: "/worksDetails/:uuid?/:activityUuid?",
      name: "worksDetails",
      component: worksDetails,
      meta: {
        title: "参赛作品详情",
      },
    },
    // 设计市场-活动详情--获奖作品详情
    {
      path: "/winDetails",
      name: "winDetails",
      component: winDetails,
      meta: {
        title: "获奖作品详情",
      },
    },
    // 赋码追溯手动创建
    {
      path: "/codeTraceability",
      name: "codeTraceability",
      component: codeTraceability,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-赋码追溯",
      },
    },
    // 赋码追溯系统创建
    {
      path: "/codeTraceabilityOther",
      name: "codeTraceabilityOther",
      component: codeTraceabilityOther,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-赋码追溯",
      },
    },
    // 赋码追溯首页
    {
      path: "/reversoContext",
      name: "reversoContext",
      component: reversoContext,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-赋码追溯",
      },
    },
    // 供需首页
    {
      path: "/supplyHome",
      name: "supplyHome",
      component: supplyHome,
      meta: {
        title: "宁夏工业企业数字化转型公共服务平台-供需首页",
      },
    },
    {
      path: "/enter",
      name: "enter",
      component: enter,
      meta: {
        title: "供需-服务商入驻",
      },
    },
    {
      path: "/demandList",
      name: "demandList",
      component: demandList,
      meta: {
        title: "供需-需求列表",
      },
    },
    {
      path: "/demandDetails",
      name: "demandDetails",
      component: demandDetails,
      meta: {
        title: "供需-需求详情",
      },
    },
    {
      path: "/serviceList/:classifyOne?/:classifyTwo?",
      name: "serviceList",
      component: serviceList,
      meta: {
        title: "供需-服务列表",
      },
    },
    {
      path: "/serviceDetails",
      name: "serviceDetails",
      component: serviceDetails,
      meta: {
        title: "供需-服务详情",
      },
    },
    {
      path: "/dynamicsList",
      name: "dynamicsList",
      component: dynamicsList,
      meta: {
        title: "供需-对接案例列表",
      },
    },
    {
      path: "/dynamicsDetails",
      name: "dynamicsDetails",
      component: dynamicsDetails,
      meta: {
        title: "供需-对接案例详情",
      },
    },
    {
      path: "/offlineList",
      name: "offlineList",
      component: offlineList,
      meta: {
        title: "供需-线下撮合列表",
      },
    },
    {
      path: "/offlineDetails",
      name: "offlineDetails",
      component: offlineDetails,
      meta: {
        title: "供需-线下撮合详情",
      },
    },
    {
      path: "/qualityServiceProviderList",
      name: "qualityServiceProviderList",
      component: qualityServiceProviderList,
      meta: {
        title: "供需-优质服务商列表",
      },
    },
    {
      path: "/qualityServiceProviderDetails/:enterPriseId",
      name: "qualityServiceProviderDetails",
      component: qualityServiceProviderDetails,
      meta: {
        title: "供需-优质服务商详情",
      },
    },
    // 产品选型首页
    {
      path: "/productHome",
      name: "productHome",
      component: productHome,
      children: [],
      meta: {
        title: "产品选型--首页",
      },
    },
    {
      path: "/productList",
      name: "productList",
      component: productList,
      children: [],
      meta: {
        title: "产品选型--产品列表",
      },
    },
    {
      path: "/specList",
      name: "specList",
      component: specList,
      children: [],
      meta: {
        title: "产品选型--规格列表",
      },
    },
    {
      path: "/newSpecList",
      name: "newSpecList",
      component: newSpecList,
      meta: {
        title: "产品选型--规格列表",
      },
    },
    {
      path: "/productDetails",
      name: "productDetails",
      component: productDetails,
      children: [],
      meta: {
        title: "产品选型--规格详情",
      },
    },
    {
      path: "/seriesDetails",
      name: "seriesDetails",
      component: seriesDetails,
      children: [],
      meta: {
        title: "产品选型--产品详情",
      },
    },
    {
      path: "/productCompare",
      name: "productCompare",
      component: productCompare,
      children: [],
      meta: {
        title: "产品选型--产品对比",
      },
    },
    {
      path: "/productOrderPage",
      name: "productOrderPage",
      component: productOrderPage,
      children: [],
      meta: {
        title: "产品选型--经销商下单",
      },
    },
    {
      path: "/specOrderCar",
      name: "specOrderCar",
      component: specOrderCar,
      meta: {
        title: "产品选型--经销商订货单",
      },
    },
    {
      path: "/lineDetails/:uuid",
      name: "lineDetails",
      component: lineDetails,
      meta: {
        title: "供需-撮合详情",
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  let path = to.fullPath
  // 判断该路由是否需要登录权限
  let token = cookies.get("api_token_new")
  if (to.meta.content) {
    const head = document.getElementsByTagName('head')[0];
    // 删除现有名称为 "keywords" 和 "description" 的 meta 标签
    const existingKeywordsMeta = document.querySelector('meta[name="keywords"]');
    if (existingKeywordsMeta) {
      existingKeywordsMeta.remove(); // 移除现有的关键词 meta 标签
    }
    const existingDescriptionMeta = document.querySelector('meta[name="description"]');
    if (existingDescriptionMeta) {
      existingDescriptionMeta.remove(); // 移除现有的描述 meta 标签
    }

    // 创建并设置新的关键词和描述 meta 标签
    const keywordsMeta = document.createElement('meta');
    keywordsMeta.setAttribute('name', 'keywords');
    keywordsMeta.setAttribute('content', to.meta.content.keywords);
    head.appendChild(keywordsMeta); // 添加新的关键词 meta 标签

    const descriptionMeta = document.createElement('meta');
    descriptionMeta.setAttribute('name', 'description');
    descriptionMeta.setAttribute('content', to.meta.content.description);
    head.appendChild(descriptionMeta); // 添加新的描述 meta 标签

    // 可选：如果需要，更新名为 "content" 的其他 meta 标签
    const contentMeta = document.querySelector('meta[name="content"]');
    if (contentMeta) {
      contentMeta.setAttribute('content', to.meta.content); // 更新 content 属性
    }
  }
  if (to.meta.requireAuth) {
    if (token) {
      next({
        path: from.fullPath,
      })
    } else {
      next()
    }
  }
  if (path != "/undefined") {
    store.commit("vuexAllPark", true)
  } else {
  }
  if (from.name == "login" && to.name == "printPlaceAnOrder") {
    next("/print")
  }
  store.commit("routerPathVuex", path)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js